import type { ParentType } from '@risksmart-app/domain/src/types/consts/parent-type';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import { RiskAssessmentResultControlType as Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';

import type { AssessmentTypeEnum } from '../types';

export type RiskAssessmentResultFormIds = Extract<
  ParentType,
  | 'controlled_risk_assessment_result'
  | 'uncontrolled_risk_assessment_result'
  | 'risk_controlled_oversight_result'
  | 'risk_uncontrolled_oversight_result'
  | 'risk_controlled_internal_audit_result'
  | 'risk_uncontrolled_internal_audit_result'
>;

// controlType is undefined until the user picks a result type (CUS-255); an
// unpicked value resolves to the uncontrolled form, matching the previous default.
export const getParentTypeFromControlType = (
  controlType: Risk_Assessment_Result_Control_Type_Enum | undefined,
  assessmentMode?: AssessmentTypeEnum
): RiskAssessmentResultFormIds => {
  switch (assessmentMode) {
    case 'oversight_assessment':
      return controlType === Risk_Assessment_Result_Control_Type_Enum.Controlled
        ? Parent_Type_Enum.RiskControlledOversightResult
        : Parent_Type_Enum.RiskUncontrolledOversightResult;
    case 'internal_audit_report':
      return controlType === Risk_Assessment_Result_Control_Type_Enum.Controlled
        ? Parent_Type_Enum.RiskControlledInternalAuditResult
        : Parent_Type_Enum.RiskUncontrolledInternalAuditResult;
    case 'rating':
    case undefined:
      return controlType === Risk_Assessment_Result_Control_Type_Enum.Controlled
        ? Parent_Type_Enum.ControlledRiskAssessmentResult
        : Parent_Type_Enum.UncontrolledRiskAssessmentResult;
  }
};
